module.exports = __webpack_public_path__ + "EAP Application.pdf";